<template>
  <div v-if="loading">
    <div class="relative rounded-2xl overflow-hidden h-84 bg-grey-light-200">
      <Skeleton class="absolute inset-0 w-full h-full" />
    </div>
  </div>

  <div v-else-if="id" @click="$emit('click')" class="cursor-pointer">
    <div class="relative rounded-2xl overflow-hidden h-48 sm:h-64 md:h-80 bg-grey-light-200">
      <div class="block relative rounded-2xl overflow-hidden h-full bg-grey-light-200">
        <img v-if="logo" :src="logo" :alt="name" class="w-full h-full object-cover object-center" loading="lazy" />
        <img v-else :src="DefaultImage" :alt="name" class="h-full object-center" loading="lazy" />

        <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent">
          <div class="absolute top-6 left-6">
            <div class="flex items-center gap-2 mb-2">
              <h2 class="text-white text-3xl font-bold">
                {{ name }}
              </h2>
              <span
                v-if="isNewStore(createdAt)"
                class="bg-blue-50 text-blue-700 text-xs font-semibold px-2 py-1 rounded-full"
              >
                New
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import DefaultImage from '@/assets/logo.svg';
import { Skeleton } from '@/components/ui/skeleton';
import { isNewStore } from '@/utils/stores.utils';

defineProps<{
  id: string | undefined;
  name: string | undefined;
  logo: string | undefined;
  createdAt: string | undefined;
  loading: boolean;
}>();

defineEmits<{
  click: [];
}>();
</script>
